// import { Carousel } from "antd"
import banner from "@/assets/images/banner-img.png"
import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"
import Sider from "./sider"

function Banner({ hasSider = true }) {
  const classnames = classModuleGenerator(styles)

  // const banners = [
  //   "http://file.xueda.com/Sowing/515917d16b91442.jpg",
  //   "http://file.xueda.com/Sowing/6a4405cf132f4e0.png",
  //   "http://www.xueda.com/images/banner/guanyuwomen2021.jpg",
  // ]

  return (
    <div className={classnames("main-container")}>
      <div
        className={classnames("main-container__inner")}
        onClick={() => {
          window.openJesongChatByGroup(121, 52601)
          return false
        }}
      >
        {hasSider && <Sider />}
        <div className={classnames("banner-container")}>
          {/* <div className={classnames("banner-only", "clearfix")}>
            <img src={banner} alt="" style={{}} />
            <div className={classnames("banner-only__text")}>
              <h1>专注个性化教育22年</h1>
              <h2>上学大中职, 考理想本科</h2>
              <button
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                升学班型选择
              </button>
            </div>
          </div>
           */}
        </div>
      </div>
      {/* <div className={classnames("banner-list")}>
        <Carousel autoplay={true}>
          {banners.map((m) => {
            return (
              <div key={m}>
                <div
                  style={{
                    width: "100%",
                    height: "550px",
                    background: `url(${m}) no-repeat center/cover`,
                  }}
                ></div>
              </div>
            )
          })}
        </Carousel>
      </div> */}
    </div>
  )
}

export default Banner
